import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Perks({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M4 5.5C4 3.01472 6.01472 1 8.5 1C9.91363 1 11.175 1.65183 12 2.67134C12.825 1.65183 14.0864 1 15.5 1C17.9853 1 20 3.01472 20 5.5C20 7.98528 17.9853 10 15.5 10H12H8.5C6.01472 10 4 7.98528 4 5.5ZM11 8V5.5C11 4.11929 9.88071 3 8.5 3C7.11929 3 6 4.11929 6 5.5C6 6.88071 7.11929 8 8.5 8H11ZM13 8H15.5C16.8807 8 18 6.88071 18 5.5C18 4.11929 16.8807 3 15.5 3C14.1193 3 13 4.11929 13 5.5V8ZM1 12C1 11.4477 1.44772 11 2 11H12H22C22.5523 11 23 11.4477 23 12V22C23 22.5523 22.5523 23 22 23H12H2C1.44772 23 1 22.5523 1 22V12ZM3 13V21H11V13H3ZM13 13V21H21V13H13Z"
        fill={iconColor}
      />
    </Svg>
  );
}
